import Vue from 'vue';
import store from '../../store/store';
import numeral from 'numeral';
import moment from 'moment';
import { getCurrentMonthDataFromContract, validateArray } from './util.js'

Vue.filter("fxformat", function(value) {
    return numeral(value).format("0,0.0000");
})

Vue.filter("priceformat", function (value) {
    return numeral(value).format("0,0.00");
});

Vue.filter("priceformatPPL", function (value) {
    if (value === 'N/A')
        return value;
    return `${numeral(value).format("0,0.00")} ppl`;
});

Vue.filter("pricedeltaformat", function (value) {
    if (value > 0){
        return numeral(value).format("+ 0,0.00");
    }
    else if (value < 0){
        return numeral(value).format("- 0,0.00");
    }
    else {
        return numeral(value).format("0,0.00");
    }
});

Vue.filter("iceformat", function (value) {
    return numeral(value).format("0,0.00");
});

Vue.filter("volumeformat", function (value) {
    return numeral(value).format("0,0");
});

Vue.filter("timeperiodgraphs", function (value) {
    switch (value){
        case 0:
            return 'Last 3 hours';
        case 1:
            return 'Last 24 hours';
        case 2:
            return 'Last 3 days';
        case 3:
            return 'Last 7 days';
    }
});

Vue.filter("creditdaysformat", function (value) {
    switch (value){
        case 0:
            return 'Prepayment';
        case 1:
            return value + ' Day';
        case null:
            return 'N/A'
        default:
            return value + ' Days';
    }
});

Vue.filter("fueltype", function (fuel_id){
    let fuel = ''
    const fuelsList = store._modules.root.state.fuelsType.fuels
    const { GasoilId, DieselId, BlendedGasoilId, BlendedDieselBioId } = store._modules.root.state.metadata.productConfig
    if (fuelsList){
        fuel = fuelsList.find(fuel => fuel._id == fuel_id)
        if (fuel){
            if (fuel._id === BlendedGasoilId){
                return fuelsList.find(fuel => fuel._id === GasoilId).name
            }
            else if (fuel._id === BlendedDieselBioId){
                return fuelsList.find(fuel => fuel._id === DieselId).name
            }
            else{
                return fuel.name
            }
        }
    }
    return 'N/A'
});

Vue.filter("offerbiopricing", function (fuel_id){
    let fuel = ''
    const fuelsList = store._modules.root.state.fuelsType.fuels

    if (fuelsList){
        fuel = fuelsList.find(fuel => fuel._id == fuel_id)
        if (fuel){
            if (fuel.type == 'NOT4SALE'){
                return "Split"
            }
            else{
                return "Straight"
            }
        }
    }
    return 'N/A'
});

Vue.filter("rawfueltype", function (fuel_id){
    let fuel = ''
    const fuelsList = store._modules.root.state.fuelsType.fuels
    if (fuelsList){
        fuel = fuelsList.find(fuel => fuel._id == fuel_id)
        if (fuel){
            return fuel.name
        }
    }
    return 'N/A'
});

Vue.filter("terminalsname", (terminal_id)=>{
    let terminal;

    const terminalsList = store._modules.root.state.terminals.terminals

    if(terminalsList){
        terminal=terminalsList.find(terminal=>terminal._id===terminal_id)
    }

    if(terminal){
        return terminal.name
    }
    else{
        return 'N/A'
    }
})

Vue.filter("networksname", (network_id)=> {
    let network = null;
    const networksList = store.getters["metadata/networks"];
    if (networksList) {
        network = networksList.find(({_id}) => _id === network_id);
    }
    return network ? network.name : 'N/A';
})
Vue.filter("offerpricingmethod", function (type_id, productSelectedIndex){
    switch (type_id) {
      case "D1":
        return "D1";
      case "D2":
        return "D2";
      case "TRACKING":
        if (productSelectedIndex === 3) {
          return "Live Trigger";
        } else {
          return "Live";
        }
      case "FIXED":
        return "Fixed";
      case "SETTLEMENT":
        return "Trade At Settlement";
      default:
        return "N/A";
    }
});

Vue.filter("offerpriceinputtype", function (type_id, isPricingEngineEnabled){
    switch (type_id){
        case "PREMIUM":
            return isPricingEngineEnabled ? "Price Rules" : "Premium (ppl)";
        case "TOTAL":
            return "Final price (ppl)";
        default:
            return "N/A";
    }
});

Vue.filter("biopricingtype", function (type_id){
    switch (type_id){
        case "STRAIGHT":
            return "Straight";
        case "SPLIT":
            return "Split Quote";
        default:
            return "N/A";
    }
});

Vue.filter("fuelmeasurementtype", function(fuel_measurement_id){
    switch (fuel_measurement_id){
        case 'STANDARD':
            return 'Standard';
        case 'AMBIENT':
            return 'Ambient';
        default:
            return 'N/A';
    }
});

Vue.filter("collectiondaysformat", function(collectionTime){
    switch (collectionTime){
        case 0:
            return "Today Only";
        case 1:
            return "Tomorrow Only";
        case 2:
            return "Tomorrow + 1 Only";
        case 30:
            return "1 Month";
        case -1:
        case undefined:
        case null:
            return "N/A"
        default:
            return collectionTime + ' Days';
    }
});

Vue.filter("collectiondaysformatdates", function (collectionTime) {
  let timePeriod1, timePeriod2;
  switch (collectionTime) {
    case 0:
      timePeriod1 = moment();
      timePeriod2 = moment();
      break;
    case 1:
      timePeriod1 = moment().add(1, "days");
      timePeriod2 = moment().add(1, "days");
      break;
    case 2:
      timePeriod1 = moment().add(2, "days");
      timePeriod2 = moment().add(2, "days");
      break;
    case 30:
      timePeriod1 = moment();
      timePeriod2 = moment().add(30, "days");
      break;
    default:
      timePeriod1 = moment();
      timePeriod2 = moment().add(collectionTime - 1, "days");
  }
  return `${moment(timePeriod1).format("DD/MM/YYYY")} - ${moment(timePeriod2).format("DD/MM/YYYY")}`;
});

Vue.filter("liftingperiodformat", function (offer) {
  if (offer.liftingPeriod && offer.liftingPeriod.length === 2) {
    return `${moment.parseZone(offer.liftingPeriod[0]).format(
      "DD/MM/YYYY"
    )} - ${moment.parseZone(offer.liftingPeriod[1]).format("DD/MM/YYYY")}`;
  }
  return "N/A"
});

Vue.filter("contractfrequencytype", function (type_id){
    switch (type_id){
        case "DAILY":
            return "Daily";
        case "WEEKLY":
            return "Weekly";
        case "MONTHLY":
            return "Monthly";
        default:
            return "N/A";
    }
});

Vue.filter("offerservicetype", function (type_id){
    switch (type_id){
        case "SPOT":
            return "Ex-Rack";
        case "BUNKERING":
            return "Bunkering";
        default:
            return "N/A";
    }
});


Vue.filter("currentMonthMaximumAvailable", function (frequencyQuantity) {
  try {
    // Validate
    if (!validateArray(frequencyQuantity))
      return null;

    const month = getCurrentMonthDataFromContract(frequencyQuantity);
    let numberToReturn = 0;
    if (month)
      numberToReturn =__formatNumbersByComma(month.maximumAvailable);
    else
      numberToReturn = __formatNumbersByComma(frequencyQuantity[0].maximumAvailable);

    return numberToReturn;
  } catch (ex) {
    return null;
  }
});

Vue.filter("currentMonthTotal", function (frequencyQuantity) {
  try {
    // Validate
    if (!validateArray(frequencyQuantity))
      return null;
      
    const month = getCurrentMonthDataFromContract(frequencyQuantity);
    let numberToReturn = 0;
    if (month) 
      numberToReturn = __formatNumbersByComma(month.quantity);
    else 
      numberToReturn = __formatNumbersByComma(frequencyQuantity[0].quantity);

    return numberToReturn;
  } catch (ex) {
    return null;
  }
});

Vue.filter('formatNumber', number => {
    return __formatNumbersByComma(number);
})

function __formatNumbersByComma(number){
    const nf = new Intl.NumberFormat();
    const newNumber = nf.format(number);
    return newNumber;
}

Vue.filter("offertype", function (type_id){
    const offerType = store._modules.root.state.sellerTabs.tabSelected.type
    switch (type_id){
        case "D1":
            return "D1";
        case "D2":
            return "D2";
        case "TRACKING":
            if(offerType === "Contracts"){
                return "Live Trigger";
            }else{
                return "Live";
            }      
        case "FIXED":
            return "Fixed";
        case "SETTLEMENT":
            return "Trade At Settlement";
        default:
            return "N/A";
    }
});

Vue.filter("storagetype", function (storage_type_id){
    switch (storage_type_id){
        case 'SPOT':
            return "Spot";
        case 'BUNKERING':
            return "Bunkering";
        default:
            return "N/A";
    }
});

Vue.filter("contracttype", function (isContract){
    switch (isContract){
        case true:
            return 'Contract';
        case false:
            return 'Spot';
        default:
            return 'zzzzzz';
    }
})

// Make everything lowercase, but every first character of each word Uppercase
Vue.filter("formatWithLowerCase", function(stringValue){ 
    let newStringFormat = stringValue.toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
    .join(' ');
    return newStringFormat;
})

/* ==== Text formatting with Moment.js ==== */

Vue.filter("datetextformat", function(date){
    return moment(date).format('D MMM YYYY');
})

Vue.filter("dateformat", function(date){
    return moment(date).format('DD/MM/YYYY');
})

Vue.filter("timeformat", function(time){
    return moment(time).format('HH:mm');
})

Vue.filter("datetimeformat", function(date){
    return moment(date).format('DD/MM/YYYY[\n]HH:mm')
})

Vue.filter("datetimesortingformat", function(date){
    return moment(date).format('YYYY/MM/DD[\n]HH:mm')
});

Vue.filter("csv_datetimesortingformat", function(date){
    return moment(date).format('DD/MM/YYYY HH:mm')
})

Vue.filter("daydateformat", function(date){
    return moment(date).format('ddd, DD MMM');
})

Vue.filter("timestampformat", function(date){
    if (moment(date).year() == moment().year())
        return moment(date).format('ddd, DD MMM');
    else
        return moment(date).format('ddd, DD MMM YYYY');
})
/* ======================================== */

Vue.filter("countdownfullformat", function(seconds){
    let hours = Math.floor(seconds / 3600)
    let minutes = Math.floor(seconds / 60)
    
    if (hours > 0){
        return hours + ' hour(s) ' + Math.floor(minutes - hours * 60) + ' minute(s)'
    }
    else if (minutes > 0){
        return minutes + ' minute(s) ' + Math.floor(seconds - minutes * 60) + ' second(s)'
    }
    else {
        return Math.floor(seconds) + ' second(s)'
    }
})

Vue.filter("countdownshortformat", function(seconds){
    let hours = Math.floor(seconds / 3600)
    let minutes = Math.floor(seconds / 60)

    if (hours > 0){
        return hours + 'hr ' + Math.floor(minutes - hours * 60) + 'min'
    }
    if (minutes > 0){
        return minutes + 'min ' + Math.floor(seconds - minutes * 60) + 's'
    }
    else {
        return Math.floor(seconds) + ' second(s)'
    }
})

Vue.filter("formatMonth", function(monthNumber) {
    switch(monthNumber){
        case 1: return "January";
        case 2: return "February";
        case 3: return "March";
        case 4: return "April";
        case 5: return "May";
        case 6: return "June"; 
        case 7: return "July";
        case 8: return "August";
        case 9: return "September";
        case 10: return "October";
        case 11: return "November";
        case 12: return "December";
    }
});

Vue.filter("timecategory", function(time){
    if (time < new Date().setHours(12, 0)){
        return 'morning'
    }
    else if (time < new Date().setHours(17, 0)){
        return 'day'
    }
    else {
        return 'evening'
    }
})

Vue.filter("countdownformat",(millisecondsLeft)=>{
    return Math.round(millisecondsLeft / 1000);
})

Vue.filter("clientreference", (clientReference) => {
  return clientReference != null ? clientReference : "\u2014";
});